import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../../../service/util.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { ReportService } from '../../report.service';
import { UserData } from '../../../../providers/user-data';
import { UserProfile } from '../../../../models/user-profile.model';
import { Storage } from '@ionic/storage';
import { BdpGantungComponent } from '../../../../component/advanced-filter/bdp-gantung/bdp-gantung.component';
import * as XLSX from 'xlsx';
import { ProductRequestStatus } from '../../../../enum/ProductRequestStatus';

@Component({
  selector: 'app-report-bdp-gantung',
  templateUrl: './report-bdp-gantung.page.html',
  styleUrls: ['./report-bdp-gantung.page.scss'],
})
export class ReportBdpGantungPage implements OnInit {
  selectedCounter: any = null;
  selectedDate: any = new Date().toISOString();

  counterList: any[] = [];
  reportData: any[] = [];
  counterName: string = '';
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };
  rows: any=[];
  tempRows : any=[];
  keywordSearch:any='';
  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
  paramProductReceivingId: any = null;
  paramProductRequestId: any = null;
  paramBranchIdList: any[]=[];
  paramCounterIdList: any[]=[];
  paramWarehouseIdList: any[]=[];
  paramDocStartDate: any = null;
  paramDocEndDate: any = null;
  paramPoType:any='0';
  branchList:any[]=[];
  warehouseList:any[]=[];
  branchNameList:any='';
  warehouseNameList:any='';
  counterNameList:any='';
  requestStatus = ProductRequestStatus;
  requestStatusList = Object.keys(ProductRequestStatus).filter(
    requestStatus => typeof this.requestStatus[requestStatus] === 'number'
  );
  constructor(
    private utilService:UtilService,
    private toastCtrl:ToastController,
    private navCtrl:NavController,
    private reportService: ReportService,
    private userData: UserData,
    private storage: Storage,
    private modalController:ModalController
  ) { }

  ngOnInit() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          this.reloadTable();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  
  reloadTable() {
    this.rows =[];
    this.tempRows = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let branchIds: any[]=[];
      let counterIds: any;
      let warehouseIds: any;
      let userCounterIds =  counterIds = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
      if(this.paramBranchIdList.length>0) { 
        branchIds = this.paramBranchIdList; 
      }
      if(this.paramCounterIdList.length>0) { 
        counterIds = this.paramCounterIdList; 
      }
      else { counterIds = userCounterIds;
      }
      if(this.paramWarehouseIdList.length>0) { 
        warehouseIds = this.paramWarehouseIdList; 
      }
      let convertDate = this.utilService.convertDate(new Date());
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "branch_id_list": branchIds,
        "counter_id_list": counterIds,
        "warehouse_id_list": warehouseIds,
        "user_counter_id_list":userCounterIds,
        "product_request_id":this.paramProductRequestId,
        "product_receiving_id":this.paramProductReceivingId,
        "doc_start_date": this.paramDocStartDate ? this.paramDocStartDate :todayDate,
        "doc_end_date": this.paramDocEndDate ? this.paramDocEndDate : '4712-12-31',
        "po_type":this.paramPoType
      };
      this.reportService.reportBdpGantung(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.rows = response.results.data;        
        this.tempRows = response.results.data;
        this.branchList = response.results.branch_list;
        this.counterList = response.results.counter_list;
        this.warehouseList = response.results.warehouse_list;

        // Hitung average
        let totalSlStock = 0;
        let totalSlTime = 0;
        const count = this.rows.length;
        this.rows.forEach(row => {
          totalSlStock += row.sl_stock ? parseInt(row.sl_stock) : 0; // pastikan null-safe
          // SL Time: pastikan angka, jika string/invalid => 0
          const slTimeNum = parseInt(row.sl_time, 10); // parseInt untuk konversi string ke number
          totalSlTime += !isNaN(slTimeNum) ? slTimeNum : 0;
        });
      }, (err) => {
        this.utilService.loadingDismiss();
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }
  exportToExcelBDPGantung() {
    /* table id is passed over here */   
    let element = document.getElementById('excel-table-qty-mismatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Report BDP Gantung.xlsx');
  }
  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: BdpGantungComponent,
      componentProps: {
        branchList:this.branchList,
        counterList: this.counterList,
        warehouseList: this.warehouseList,
        paramProductReceivingId: this.paramProductReceivingId,
        paramProductRequestId: this.paramProductRequestId,
        paramBranchIdList: this.paramBranchIdList,
        paramCounterIdList: this.paramCounterIdList,
        paramWarehouseIdList: this.paramWarehouseIdList,
        paramDocStartDate: this.paramDocStartDate,
        paramDocEndDate: this.paramDocEndDate,
        paramPoType:this.paramPoType
      },
      backdropDismiss: false
    });
    console.log("BRANCH")
    console.log(this.branchList);

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      console.log(data)
      if (data.length > 0) {
        let arrBranch = [];
        if(data[0].branchId.length>0){
          for(let i=0;i<data[0].branchId.length;i++){
            arrBranch.push(data[0].branchId[i].id);
          }
        }
        let arrCounter = [];
        if(data[0].counterId.length>0){
          for(let i=0;i<data[0].counterId.length;i++){
            arrCounter.push(data[0].counterId[i].id);
          }
        }
        let arrWarehouse = [];
        if(data[0].warehouseId.length>0){
          for(let i=0;i<data[0].warehouseId.length;i++){
            arrWarehouse.push(data[0].warehouseId[i].id);
          }
        }
        this.paramProductReceivingId = data[0].productReceivingId;
        this.paramProductRequestId = data[0].productRequestId;
        this.paramBranchIdList = arrBranch;
        this.paramCounterIdList = arrCounter;
        this.counterNameList = data[0].counterName;
        this.paramWarehouseIdList = arrWarehouse;
        this.warehouseNameList = data[0].warehouseName;
        this.paramDocStartDate = data[0].docStartDate;
        this.paramDocEndDate = data[0].docEndDate;
        this.paramPoType = data[0].poType

        this.reloadTable();
      }
    });
    return await modal.present();
  }
}
